import { useState } from "react";
import { deleteCustomer } from "../../services/customer";
import { ActionIcon, Button, Modal, Text, Tooltip } from "@mantine/core";
import { FiEdit2, FiFile, FiTrash2 } from "react-icons/fi";
import CustomerEdit from './CustomerEdit';
import CustomerDetails from "./CustomerDetails.jsx";
import { getGlobalColor } from "../../services/globalColor.js";

const CustomerItem = ({ customer, getCustomer, renderOrdersChart }) => {
  const [editModal, setEditModal] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);

  const removeCustomer = async () => {
    try {
      await deleteCustomer(customer._id);
      getCustomer();
      setConfirmDeleteModal(false); // Ensure the modal is closed after deleting
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {editModal && <CustomerEdit customer={customer} setEditModalOpen={setEditModal} refreshCustomer={getCustomer} />}
      {detailsModal && <CustomerDetails customer={customer} detailsModal={detailsModal} setDetailsModal={setDetailsModal} />}

      {/* Confirmation Modal for Deleting */}
      <Modal
        opened={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        title={`¿Estás seguro que deseas eliminar a ${customer.name} de tu lista?`}
        size="lg"
      >
        <Text size="sm">
          Al eliminar a {customer.name} de tu lista no podrás deshacer la operación. <br />Esta acción es permanente.
        </Text>
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'end' }}>
          <Button onClick={() => setConfirmDeleteModal(false)} variant="transparent">Cancelar</Button>
          <Button onClick={removeCustomer} >Eliminar</Button>
        </div>
      </Modal>

      <tr key={customer.id}>

        <td>{customer.name}</td>
        <td>{customer.phone}</td>
        <td>{customer.email}</td>
        <td>
          {typeof renderOrdersChart === 'function' ? renderOrdersChart() : null}
        </td>

        <td>
          <div className="row" style={{ justifyContent: "end", gap: "5px" }}>
            <Tooltip label="Mostrar detalles" position="top">
              <ActionIcon onClick={() => setDetailsModal(true)} color={getGlobalColor().color}>
                <FiFile style={{ color: getGlobalColor().contrast || getGlobalColor().text }} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Editar" position="top">
              <ActionIcon onClick={() => setEditModal(true)} color={getGlobalColor().color}>
                <FiEdit2 style={{ color: getGlobalColor().contrast || getGlobalColor().text }} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Eliminar" position="top">
              <ActionIcon onClick={() => setConfirmDeleteModal(true)} color={getGlobalColor().color}>
                <FiTrash2 style={{ color: getGlobalColor().contrast || getGlobalColor().text }} />
              </ActionIcon>
            </Tooltip>
          </div>
        </td>
      </tr>
    </>
  );
};

export default CustomerItem;
